import React, { useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t, lang, setLang } = useLanguage();

  const LangSwitch = ({ className = '' }) => (
    <div
      className={`inline-flex items-center rounded-lg border border-purple-200 overflow-hidden ${className}`}
      role="group"
      aria-label={t('nav.langLabel')}
    >
      <button
        type="button"
        onClick={() => setLang('es')}
        className={`px-2.5 py-1 text-sm font-semibold transition-colors ${
          lang === 'es'
            ? 'bg-purple-600 text-white'
            : 'bg-white text-gray-600 hover:text-purple-700'
        }`}
        aria-pressed={lang === 'es'}
      >
        {t('nav.langEs')}
      </button>
      <button
        type="button"
        onClick={() => setLang('en')}
        className={`px-2.5 py-1 text-sm font-semibold transition-colors ${
          lang === 'en'
            ? 'bg-purple-600 text-white'
            : 'bg-white text-gray-600 hover:text-purple-700'
        }`}
        aria-pressed={lang === 'en'}
      >
        {t('nav.langEn')}
      </button>
    </div>
  );

  return (
    <header className="bg-white shadow-md">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <div className="flex items-center">
          <img
            src="https://primetaxonline.com/img/logos/techrabbitlogo.jpeg"
            alt="Tech Rabbit Logo"
            className="h-10 mr-2"
          />
        </div>

        <nav className="hidden md:flex items-center space-x-8">
          <a href="#services" className="text-purple-600 font-medium hover:text-purple-800">
            {t('nav.services')}
          </a>
          <a href="#monitoring" className="text-gray-600 font-medium hover:text-purple-600">
            {t('nav.monitoring')}
          </a>
          <a href="#about" className="text-gray-600 font-medium hover:text-purple-600">
            {t('nav.about')}
          </a>
          <a href="#contact" className="text-gray-600 font-medium hover:text-purple-600">
            {t('nav.contact')}
          </a>
          <LangSwitch />
        </nav>

        <div className="flex items-center gap-3 md:hidden">
          <LangSwitch />
          <button
            className="text-gray-600 focus:outline-none"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-expanded={isMenuOpen}
            aria-label="Menu"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
            </svg>
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden bg-white px-4 py-2 shadow-inner">
          <a href="#services" className="block py-2 text-purple-600 font-medium" onClick={() => setIsMenuOpen(false)}>
            {t('nav.services')}
          </a>
          <a href="#monitoring" className="block py-2 text-gray-600 font-medium hover:text-purple-600" onClick={() => setIsMenuOpen(false)}>
            {t('nav.monitoring')}
          </a>
          <a href="#about" className="block py-2 text-gray-600 font-medium hover:text-purple-600" onClick={() => setIsMenuOpen(false)}>
            {t('nav.about')}
          </a>
          <a href="#contact" className="block py-2 text-gray-600 font-medium hover:text-purple-600" onClick={() => setIsMenuOpen(false)}>
            {t('nav.contact')}
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;
